export const SOUNDS = [
    {
        value: 'done-deal',
        label: 'account.settings.notifications.sounds.done-deal',
    },
    {
        value: 'hammered',
        label: 'account.settings.notifications.sounds.hammered',
    },
    {
        value: 'likeable',
        label: 'account.settings.notifications.sounds.likeable',
    },
    {
        value: 'waitingfor',
        label: 'account.settings.notifications.sounds.waiting-for',
    },
    {
        value: 'wakeup-call',
        label: 'account.settings.notifications.sounds.wakeup-call',
    },
    { value: '', label: 'account.settings.notifications.sounds.no-audio' },
];
export const NOTIFICATION_ROOM_TYPES = [{
        value: 'all',
        label: 'account.settings.notifications.type.all'
    }, {
        value: 'personal',
        label: 'account.settings.notifications.type.personal'
    }, {
        value: 'shared',
        label: 'account.settings.notifications.type.shared'
    }];
export var BrowserNotificationsActions;
(function (BrowserNotificationsActions) {
    BrowserNotificationsActions["UPDATE_STATUS"] = "BROWSER_NOTIFICATIONS/UPDATE_STATUS";
    BrowserNotificationsActions["SET_IS_UPDATING"] = "BROWSER_NOTIFICATIONS/SET_IS_UPDATING";
    BrowserNotificationsActions["SET_ERROR"] = "BROWSER_NOTIFICATIONS/SET_ERROR";
    BrowserNotificationsActions["CLEAR_ERROR"] = "BROWSER_NOTIFICATIONS/CLEAR_ERROR";
})(BrowserNotificationsActions || (BrowserNotificationsActions = {}));
export const CLEAR_ERROR_TIMEOUT = 500;
export const DEFAULT_PHONE_PLACEHOLDER = '201 555 0123';
